import { environment } from '../../../environments/environment';

/** True for proxied `/api/*` and absolute Skilled API URLs. */
export function isSkilledApiRequest(url: string): boolean {
  if (!url) return false;
  if (url.startsWith('/api/') || url === '/api') return true;

  try {
    const origin =
      typeof globalThis !== 'undefined' && 'location' in globalThis
        ? globalThis.location.origin
        : 'http://localhost';
    const resolved = new URL(url, origin);
    if (resolved.pathname.startsWith('/api')) return true;

    const allowedOrigins = new Set(
      [environment.apiBaseUrl, environment.publicApiBaseUrl]
        .filter((b) => /^https?:\/\//i.test(b))
        .map((b) => new URL(b).origin),
    );
    return allowedOrigins.has(resolved.origin);
  } catch {
    return false;
  }
}
